import React from 'react'
import UIStateContainer from '../Containers/UIStateContainer'
import IconButton from '@mui/material/IconButton'
import AppBar from '@mui/material/AppBar'
import Box from '@mui/material/Box'
import Toolbar from '@mui/material/Toolbar'
import LinearProgress from '@mui/material/LinearProgress'
import MenuIcon from '@mui/icons-material/Menu'
import AccountMenu from './AccountMenu'
import {
  contentColumnMaxWidthSx,
  contentColumnShellSx
} from './contentColumn'
import anearLogo from '../../images/anear_me_logo.webp'
import useNavigation from '../Utils/navigationUtils'

const Header = () => {
  const uiContainer = UIStateContainer.useContainer()
  const { navigateToHome } = useNavigation()

      return (
        <Box sx={{
          ...contentColumnShellSx,
          pt: 0.25
        }}>
          <Box
            sx={{
              position: 'relative',
              ...contentColumnMaxWidthSx
            }}
          >
            <AppBar
              position="sticky"
              sx={{
                bgcolor: '#151A23',
                boxShadow: '0 2px 8px rgba(0,0,0,0.3), inset 0 0 0 1px rgba(255,255,255,0.1)',
                borderBottom: '1px solid rgba(255,255,255,0.1)',
                borderRadius: '8px'
              }}
            >
              <Toolbar sx={{ px: 1.5, minHeight: '62px !important' }}>
                <Box
                  sx={{
                    position: 'relative',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '100%',
                    minHeight: '2.5rem'
                  }}
                >
                  <Box
                    sx={{
                      position: 'absolute',
                      left: 0,
                      top: '50%',
                      transform: 'translateY(-50%)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'flex-start'
                    }}
                  >
                    <IconButton
                      sx={{
                        marginLeft: -1,
                        color: '#E6E9EF',
                        opacity: uiContainer.isHeaderDimmed ? 0.35 : 1,
                        transition: 'opacity 200ms ease-out'
                      }}
                      aria-label="Menu"
                      onClick={_ => {
                        // Lifting the lights when the "burger" is opened.
                        uiContainer.undimHeader()
                        uiContainer.openBurgerMenu()
                      }}
                    >
                      <MenuIcon sx={{ color: '#E6E9EF', fontSize: '2.1rem' }} />
                    </IconButton>
                  </Box>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: '100%',
                      minWidth: 0,
                      px: { xs: 6.5, sm: 7.5 }
                    }}
                  >
                    <Box
                      role="button"
                      tabIndex={0}
                      aria-label="Go to home"
                      onClick={() => {
                        uiContainer.undimHeader()
                        navigateToHome()
                      }}
                      onKeyDown={(event) => {
                        if (event.key === 'Enter' || event.key === ' ') {
                          event.preventDefault()
                          uiContainer.undimHeader()
                          navigateToHome()
                        }
                      }}
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '100%',
                        maxWidth: '100%',
                        cursor: 'pointer'
                      }}
                    >
                      <Box
                        component="img"
                        src={anearLogo}
                        alt="Anear Apps"
                        sx={{
                          height: '2.25rem',
                          ml: 0.5,
                          opacity: uiContainer.isHeaderDimmed ? 0.35 : 1,
                          transition: 'opacity 200ms ease-out',
                          maxWidth: '100%',
                          objectFit: 'contain',
                          display: 'block'
                        }}
                      />
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      position: 'absolute',
                      right: 0,
                      top: '50%',
                      transform: 'translateY(-50%)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'flex-end'
                    }}
                  >
                    <AccountMenu />
                  </Box>
                </Box>
              </Toolbar>
            </AppBar>
          {uiContainer.isInProgress && (
            <LinearProgress
              variant="indeterminate"
              color="primary"
              sx={{
                // Slightly thicker + faint track so it reads on dark header
                height: '0.25rem',
                borderRadius: '0.25rem',
                backgroundColor: 'rgba(255,255,255,0.08)',
                '& .MuiLinearProgress-bar': { borderRadius: '0.25rem' }
              }}
            />
          )}
          </Box>
        </Box>
      )
}
export default Header
